module.exports = __webpack_public_path__ + "static/media/email-creator.6da27030.svg";